import CarLeasing from './CarLeasing';
import { NAME } from './constants';

export default {
  NAME,
  CarLeasing,
};
